import React from 'react';
import { Input } from '../../atoms/Input';
import { Button } from '../../atoms/Button';
import { type User } from '../../../services/usersService';

export interface ShadowBanFormProps {
  user: User;
  shadowBanDate: string;
  onShadowBanDateChange: (date: string) => void;
  onSave: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ShadowBanForm = ({
  user,
  shadowBanDate,
  onShadowBanDateChange,
  onSave,
  onCancel,
  isLoading = false,
}: ShadowBanFormProps) => {
  return (
    <div className="py-4">
      <div className="mb-4">
        <p className="text-sm text-gray-600 mb-2">
          <strong>Kullanıcı:</strong> {user.username}
        </p>
        <p className="text-sm text-gray-600 mb-4">
          <strong>E-posta:</strong> {user.email}
        </p>
        {user.shadowBannedUntil && (
          <p className="text-sm text-gray-600 mb-4">
            <strong>Mevcut Shadow Ban Tarihi:</strong>{' '}
            {new Date(user.shadowBannedUntil).toLocaleString('tr-TR')}
          </p>
        )}
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Yeni Shadow Ban Tarihi (Boş bırakırsanız shadow ban kaldırılır)
        </label>
        <Input
          type="datetime-local"
          value={shadowBanDate}
          onChange={(e) => onShadowBanDateChange(e.target.value)}
          className="w-full"
        />
      </div>
      <div className="flex justify-end gap-3">
        <Button variant="secondary" onClick={onCancel}>
          İptal
        </Button>
        <Button variant="primary" onClick={onSave} isLoading={isLoading}>
          Kaydet
        </Button>
      </div>
    </div>
  );
};
